import React, { useEffect, useState } from "react";
import api from '../../../config/axiosConfig';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Button from 'react-bootstrap/Button';
import Table from 'react-bootstrap/Table';
import loaderGif from "../../../assets/loader.gif";

const OrderList = () => {
    const [data, setData] = useState([]); // Should be array, not object
    const [loader, setLoader] = useState(false);

    const getData = async () => {
        try {
            setLoader(true);
            const dataResponse = await api.get("/orders/orderlist");
            const filteredData = dataResponse.data.filter(item => item.status === 1);
            setData(filteredData);

        } catch (error) {
            console.error('Fetching data failed:', error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        getData();
    }, []);

    const handleItemStatus = async (itemId, status) => {
        try {
            setLoader(true);
            await api.put(`/orders/${itemId}`, { status: status });
            await getData(); // Refresh data after status update
        } catch (error) {
            console.error('Status update failed:', error);
        } finally {
            setLoader(false);
        }
    };

    return (
        <Container fluid>
            <Row className="mt-4">
                {loader ? (
                    <div className="text-center w-100">
                        <img src={loaderGif} alt="Loading..." style={{ width: "50px" }} />
                    </div>
                ) : (
                    <Table bordered>
                        <thead>
                            <tr>
                                <th>Customer</th>
                                <th>Reference</th>
                                <th>Item</th>
                                <th>Quantity</th>
                                <th>Notes</th>
                                <th>Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 ? (
                                data.map((item) => (
                                    <tr key={item.id}>
                                        <td>{item.accountName}</td>
                                        <td>{item.referenceCode}</td>
                                        <td>{item.itemName}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.notes}</td>
                                        <td>{item.StatusName}</td>
                                        <td>
                                            <Button
                                                variant="primary"
                                                size="sm"
                                                className="m-2"
                                                onClick={() => handleItemStatus(item.id, 2)}
                                            >
                                                Complete
                                            </Button>
                                            <Button
                                                variant="danger"
                                                size="sm"
                                                onClick={() => handleItemStatus(item.id, 0)}
                                            >
                                                Cancel
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7" className="text-center">No orders found.</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                )}
            </Row>
        </Container>
    );
};

export default OrderList;
